import AppConstant from '../../../config/app.constants';

class AtmMakesController {
    /*@ngInject*/
    constructor(AtmMakesService, Modal, DateUtil) {
        this.AtmMakesService = AtmMakesService;
        this.Modal = Modal;
        this.DateUtil = DateUtil;

        this.model = {
            atmMakes: [],
            originalAtmMakes: [],
            searchText: '',
            loading: true,
            saving: false
        }
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
    }

    $onInit() {
        this.loadData();
    }

    addAtmMake() {
        this.Modal.createAtmMake(({ modal, atmMake }) => {
            this.model.saving = true;
            this.AtmMakesService.create(atmMake)
                .then(() => {
                    modal.close();
                    this.loadData();
                })
                .catch((err) => {
                    this.Modal.errorModal(err.data ? err.data.message : 'Error creating ATM Make');
                })
                .finally(() => {
                    this.model.saving = false;
                });
        }, ({ modal }) => {
            if (modal) modal.close();
        });
    }

    removeAtmMake(index) {
        this.model.atmMakes.splice(index, 1);
    }

    loadData() {
        this.model.loading = true;
        this.AtmMakesService.all(this.model.searchText, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
            .then((data) => {
                this.pagination.total = data.total;
                this.model.atmMakes = angular.copy(data.results);
                this.model.originalAtmMakes = Object.freeze(angular.copy(data.results));
            })
            .catch((err) => {
                this.Modal.errorModal(err.message);
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    pageChange() {
        this.loadData();
    }

    disableUpdate() {
        if (!this.model.atmMakes) return true;
        let emptyRecords = this.model.atmMakes.filter(i => !i.vendorName);
        return emptyRecords.length > 0;
    }

    compareArrays(originalArray, changedArray) {
        const changed = [];
        const removed = [];
        const originalMap = new Map();

        originalArray.forEach(item => originalMap.set(item.id, item));
        changedArray.forEach(item => {
            const originalItem = originalMap.get(item.id);
            if (!originalItem) {
                changed.push(item);
                return;
            };

            if (item.vendorName !== originalItem.vendorName || item.active !== originalItem.active) {
                changed.push(item);
            }
            originalMap.delete(item.id);
        });

        removed.push(...originalMap.values());
        if (changed.length === 0 && removed.length === 0) {
            return null;
        }
        return { changed, removed };
    }

    updateAtmMakes() {
        this.model.saving = true;
        const diff = this.compareArrays(this.model.originalAtmMakes, this.model.atmMakes);
        if (!diff) {
            this.model.saving = false;
            return;
        }

        let promises = [];
        if (diff.changed && diff.changed.length) {
            diff.changed.forEach(item => {
                if (item.id) {
                    promises.push(this.AtmMakesService.update(item.id, item));
                } else {
                    promises.push(this.AtmMakesService.create(item));
                }
            });
        }
        if (diff.removed && diff.removed.length) {
            diff.removed.forEach(item => {
                if (item.id) promises.push(this.AtmMakesService.remove(item.id));
            });
        }

        Promise.all(promises).then(() => {
            this.loadData();
        }).catch((err) => {
            this.Modal.errorModal(err.data ? err.data.message : 'Error updating ATM Makes');
        }).finally(() => {
            this.model.saving = false;
        });
    }

    getStatusLabel(item) {
        return item && item.active ? 'Active' : 'Inactive';
    }

    getUpdatedByLabel(item) {
        if (!item || !item.updatedByUser) return 'N/A';
        const { id, firstName, lastName } = item.updatedByUser;
        const fullName = [firstName, lastName].filter(Boolean).join(' ');
        return id ? `${id} | ${fullName || 'N/A'}` : (fullName || 'N/A');
    }
}

export default AtmMakesController;



// WEBPACK FOOTER //
// ./client/app/components/service_settings/atm-makes/atm-makes.controller.js